module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 80
// module chunks = 0